export default "../static/img/37fc01d91728f8a8c04d24f3d4d5a534.jpg";